import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]




export default /*#__PURE__*/_defineComponent({
  __name: 'CapitalizedText',
  props: {
    text: null,
    big_style: null,
    small_style: null
  },
  setup(__props: any) {

const props = __props as {
  text: string;
  big_style: string;
  small_style: string;
};

// Component imports


const capitalizeText = (text: string) => {
  return Array.from(text)
    .map((c) => {
      const output =
        c === c.toUpperCase()
          ? `<span class="${props.big_style}">${c}</span>`
          : `<span class="${props.small_style}">${c.toUpperCase()}</span>`;
      return output;
    })
    .join('');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    innerHTML: capitalizeText(__props.text)
  }, null, 8, _hoisted_1))
}
}

})